
import { Component, Vue } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonBlockTitle from '@/components/common/CommonBlockTitle.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import { homeTitle } from '@/config/config';
import { homeRecommendPaihang } from '@/config/stat';
import { checkLogin, pushBy2804 } from '@/utils/tools';
import {
  getRankAuthor,
  getHomeAnalystRank,
  getNewWealthYear,
  getNewWealthBanner,
  postNewWealthSaw,
} from '@/apis/index';

@Component({
  components: {
    CommonBlockLine,
    CommonBlockTitle,
    CommonLoading,
    CommonRankNumber,
  },
})
export default class AnalystAgencyRank extends Vue {
  // 机构数据
  analystList = [];
  // 分析师数据
  agencyList = [];
  // 机构数据
  analystStatus = 0;
  // 分析师数据
  agencyStatus = 0;
  // 标题配置信息
  homeTitle = homeTitle;
  isShowBanner = false;
  year = '2022';
  params = {
    order_by: 1,
    type: '3m',
    start: 0,
    limit: 3,
  };
  toRank() {
    // 跳转路由 分析师
    pushBy2804('/rank', {
      tab: '2',
      agencydate: '近3月',
      agencyselect: '3m',
    });
  }
  toAgency(item: any) {
    if (!item.authorId) {
      return;
    }
    pushBy2804('/mainPage', {
      authorId: item.authorId,
      name: item.authorName,
      org: item.orgName,
    });
  }
  toOrg(item: any) {
    if (!item.orgId) {
      return;
    }
    pushBy2804('/mainPage', {
      orgId: item.orgId,
      name: item.orgName,
    });
  }
  getAuthor() {
    // 获取分析师数据
    getRankAuthor(this.params)
      .then(res => {
        if (res.statusCode === 0) {
          this.agencyList = res.data?.list;
          // 数据加载状态
          this.agencyStatus = 3;
        } else {
          this.agencyStatus = 2;
        }
      })
      .catch(() => {
        this.agencyStatus = 2;
      });
  }
  getAnalyst() {
    // 获取机构数据
    getHomeAnalystRank(this.params)
      .then(res => {
        if (res.statusCode === 0) {
          this.analystList = res.data?.list;
          // 数据加载状态
          this.analystStatus = 3;
        } else {
          this.analystStatus = 2;
        }
      })
      .catch(() => {
        this.analystStatus = 2;
      });
  }
  getNewWealth() {
    getNewWealthYear({}).then(res => {
      let { year } = res.data;
      if (!year) {
        year = new Date().getFullYear() - 1;
      }
      getNewWealthBanner({
        year,
      }).then(show => {
        this.year = year;
        this.isShowBanner = show.data.isShow;
      });
    });
  }
  sawNewWealth() {
    checkLogin(() => {
      postNewWealthSaw({
        year: this.year,
      }).then(() => {
        this.isShowBanner = false;
        homeRecommendPaihang();
        pushBy2804('/rank', {
          tab: '4',
        });
      });
    }, null);
  }
  mounted() {
    // 获取数据
    this.getAuthor();
    this.getAnalyst();
    this.getNewWealth();
  }
}
